import React, {useState} from 'react';
import {Form} from 'react-bootstrap';
import graphql from "babel-plugin-relay/macro";
import {useFragment, useMutation} from "react-relay";
import {FormProvider, useForm} from "react-hook-form";
import {useUser} from "../../hooks/useUser";
import {toast} from "react-toastify";
import InfoPanel from "../../components/common/repeated-page-panels/InfoPanel";
import {allContractsDropdown} from "../contracts/ContractFragments";
import HorizontalFormSelect from "../../components/common/horizontal-form-inputs/HorizontalFormSelect";

const FacilityInfo = ({facility, legalContracts}) => {
    const mutation = graphql`
    mutation FacilityInfoMutation($id: ID!, $legalContractId: ID!) {
        facility {
            modify(input: {facilityId: $id, legalContractId: $legalContractId}) {
                facility {
                    ...FacilityInfo_Facility
                }
            }
        }
    }`
    const facilityInfo = useFragment(graphql`
    fragment FacilityInfo_Facility on Facility {
        id
        legalContract {
            id
            name
            linesOfService {
                ...ContractLinesOfServiceFragments_LinesOfService
            }
            locations {
                ...LocationFragments_LocationDropdown
            }
        }
        applicableVersion {
           displayName
        }
        billingAddresses {
            ...ProviderBillingAddresses_Addresses
        }
        locations {
            ...FacilityLocations_Locations
        }
    }`, facility)
    const allLegalContracts = useFragment(allContractsDropdown, legalContracts).toSorted((a, b) => a.name.localeCompare(b.name)).map((c) => {return {value: c.id, label:c.name}});
    const [readMode, setReadMode] = useState(true);
    const [commitMutation, isInFlight] = useMutation(mutation);
    const methods = useForm({values: {legalContractId: facilityInfo.legalContract.id}})
    const {hasPermission} = useUser();

    const onSubmit = (data) => {
        commitMutation({variables: {
                id: facilityInfo.id,
                ...data
            }, onCompleted: (data) => {
            if(data.facility) {
                toast.success("Facility has been updated");
                setReadMode(true);
            }
            }})
    }
    const handleCancelClick = () => {
        methods.reset();
        setReadMode(true);
    }
    return (
        <FormProvider {...methods}>
            <Form noValidate onSubmit={methods.handleSubmit(onSubmit)}>
                <InfoPanel readMode={readMode}
                           onCancelChangesClick={handleCancelClick}
                           name={facilityInfo.applicableVersion.displayName}
                           isInFlight={isInFlight}
                           onUpdateDetailsClick={() => {setReadMode(false)}}
                           showUpdate={hasPermission("Facility.Update")}
                >
                    <HorizontalFormSelect options={allLegalContracts}
                                          controlId={"legalContractId"}
                                          label={"Contract"}
                                          validation={{required: "Contract is required"}}
                                          readMode={readMode} />
                </InfoPanel>
            </Form>
        </FormProvider>
    );
};

export default FacilityInfo;
